<template>
  <div
    :class="{
      'loader-icon': true,
      'loader-icon--small': small,
      'loader-icon--dark': dark,
    }"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoaderIcon',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped lang="scss">
.loader-icon {
  width: 2rem;
  aspect-ratio: 1;
  border: 1px solid theme('colors.primary');
  border-radius: 50%;
  border-color: transparent theme('colors.primary') theme('colors.primary');
  animation: rotate 1s infinite linear;
  &--small {
    width: 1rem;
    height: 1rem;
  }
  &--dark {
    border-color: transparent theme('colors.white') theme('colors.white');
  }
}
@keyframes rotate {
  to {
    transform: rotate(1turn);
  }
}
</style>
